export class ExtendedPromise<T = void> extends Promise<T> {
	resolve: (value?: T) => void;
	reject: (reason?: any) => void;

	constructor(executor = (_rs: Function, _rj: Function) => {}) {
		let resolve, reject;
		super((res, rej) => {
			resolve = res;
			reject = rej;
			executor(res, rej);
		});
		this.resolve = resolve!;
		this.reject = reject!;
	}
}
